import { Injectable } from '@angular/core';
import { AppConfig } from './app-config.model';
import { DOMAIN_CONFIG } from './domain-config';

/**
 * Resuelve la configuración de entorno en construcción (eager), antes de que
 * cualquier factory de MSAL o interceptor HTTP sea instanciado por el DI.
 * El error intencional en el constructor garantiza fallo inmediato y visible
 * si el hostname no está registrado en DOMAIN_CONFIG, en lugar de errores
 * silenciosos de autenticación más adelante.
 */
@Injectable({ providedIn: 'root' })
export class AppConfigService {
    private config: AppConfig;

    constructor() {
        const hostname = window.location.hostname;
        const cfg = DOMAIN_CONFIG[hostname];
        if (!cfg) {
            throw new Error(`No config found for hostname: ${hostname}`);
        }
        this.config = cfg;
    }

    get value(): AppConfig {
        return this.config;
    }
}
